import React from "react";
import EmptyState from "../blocks/empty-state";

const NoElements = ({ titulo, subtitulo, illustration, badge }) => {
  return (
    <EmptyState
      title={titulo}
      subtitle={subtitulo}
      illustration={illustration}
      badge={badge}
    />
  );
};

export default NoElements;
